module.exports = __webpack_public_path__ + "img/youtube.a0fcaff8.svg";